
import { reactive, ref, toRefs, defineComponent, onMounted, watch, onBeforeUnmount, } from "vue";
import { iotElevatorQuery } from "@/apis/ladderControl"
import { bindingLadder, unbindingLadder, goToFloor } from '@/apis/building'
import { ElMessage } from "element-plus";
import dialogs from '@/components/dialogs/dialogs.vue'
import paging from '@/components/paging/paging.vue'

export default defineComponent({
    components: {
        dialogs,
        paging
    },
    props: {
        buidingData: {
            type: Object,
            default: ''
        },
        floorList: {
            type: Object,
            default: ''
        }
    },
    setup(props) {

        const state = reactive({
            flag: '' as any,
            disabledFlag: true,
            centerDialogVisible: false,
            relationDialog: false,
            unbindDialogs: false,
            checkData: '',
            numbers: '',
            total: 0,
            goToFloorparams: {
                elevator_id: '',
                floor_list: []
            } as any,
            form: {
                region: ''
            },
            rules: {
                selectRules: [{ required: true, message: 'Please select Activity zone', trigger: 'blur', }]
            },
            params: {
                building_id: props.buidingData.ID,
                pageSize: 12,
                page: 1,
                limit: true
            },
            updateActiveFlag: false,
            ladderControlList: [] as any,
            relationList: [] as any,
            value: '',
            options: [
            ] as any,
            goToFloorConfirm() {
                props.floorList.forEach((item: any) => {
                    if (item.checked) {
                        state.goToFloorparams.floor_list.push(item.ID)
                    }
                })
                goToFloor(state.goToFloorparams).then((res: any) => {
                    console.log('可前往楼层结果', res)
                    if (res.code == 200) {
                        ElMessage({
                            message: "编辑成功",
                            type: "success",
                        })
                        state.centerDialogVisible = false
                        state.listQuery()
                    }
                })
            },
            checkboxChange(val: boolean) {
                state.flag = ''
                props.floorList.forEach((e: any) => {
                    if (e.checked) {
                        state.flag = e.checked
                    }
                })
                if (state.flag) {
                    state.disabledFlag = false
                } else {
                    state.disabledFlag = true
                }
            },
            dislogFn(item: any) {
                state.centerDialogVisible = true
                state.goToFloorparams.elevator_id = item.id
            },
            // 页码切换
            changePage(val: number) {
                state.params.page = val
                state.iotElevatorQuery()
            },
            cancelRelation() {
                if (state.checkData) {
                    state.unbindDialogs = true
                } else {
                    return
                }
            },
            OFF() {
                state.unbindDialogs = false
            },
            ON() {
                unbindingLadder(state.checkData).then((res: any) => {
                    console.log('解绑结果', res)
                    if (res.code == 200) {
                        state.listQuery()
                        state.unbindDialogs = false
                        ElMessage({
                            message: "梯控解绑成功",
                            type: "success",
                        })
                    } else {
                        ElMessage.error(`解绑失败：${res.msg}`)
                    }
                })
                state.unbindDialogs = false
            },
            handleClose() {
                state.relationDialog = false
            },
            checkChange(val: any) {
                console.log('复选框', val)
                state.checkData = ''
                state.relationList.forEach((item: any) => {
                    if (item.checkedFlag) {
                        state.checkData += item.id + ','
                    }
                })
                console.log('循环后的值', state.checkData)
                if (state.checkData) {
                    state.updateActiveFlag = true
                } else {
                    state.updateActiveFlag = false
                }
            },
            // 关联梯控选择器
            selcetChange(val: any) {
                console.log('选中的指', val)
                state.numbers = ''
                val.forEach((item: any) => {
                    state.numbers += item + ','
                })
                console.log('asddas0,', state.numbers)
            },
            confirm() {
                bindingLadder(props.buidingData.ID, state.numbers).then((res: any) => {
                    console.log('绑定梯控结果', res)
                    if (res.code == '200') {
                        state.listQuery()
                        state.relationDialog = false
                        ElMessage({
                            message: "关联梯控成功",
                            type: "success",
                        })
                    } else {
                        ElMessage.error(`${res.msg}`)
                    }
                })
            },
            // 梯控列表查询
            iotElevatorQuery() {
                iotElevatorQuery({ pageSize: 12, page: 1, limit: true }).then((res: any) => {
                    console.log('asdddddd', res)
                    res.data.list.forEach((item: any) => {
                        if (item.building_id > 0) {
                            item.disabled = true
                        } else {
                            item.disabled = false
                        }
                    })
                    state.ladderControlList = res.data.list
                })

            },
            // 关联梯控列表查询
            listQuery() {

                iotElevatorQuery(state.params).then((res: any) => {
                    console.log('关联梯控列表', res)
                    state.total = res.data.total
                    if (res.data.list.length > 0) {
                        res.data.list.forEach((item: any) => {
                            item.checkedFlag = false
                        });
                    }
                    state.relationList = res.data.list
                })
            },
            init() {
                state.iotElevatorQuery()
                state.listQuery()
                console.log('打卡机圣诞卡几千万', props.floorList)
                props.floorList.forEach((item: any) => {
                    item.checked = false
                })
            }
        })

        watch(() => props.buidingData, (newVal, oldVal) => {
            console.log('新数据', newVal)
            console.log('旧数据', oldVal)
            if (newVal.buildingFlag) {
                state.init()
            } else {
                return
            }
        })

        onMounted(() => {
            state.init()
        })

        return {
            ...toRefs(state)
        }
    }
})
